import { render, staticRenderFns } from "./OaBusinessFields.vue?vue&type=template&id=9f0a0150&scoped=true"
import script from "./OaBusinessFields.vue?vue&type=script&lang=js"
export * from "./OaBusinessFields.vue?vue&type=script&lang=js"
import style0 from "./OaBusinessFields.vue?vue&type=style&index=0&id=9f0a0150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a0150",
  null
  
)

export default component.exports